<template>
    <div class="card-landscape" :style="{height: mapHeight +'vw'}" :class="{sliderhidden: slidervisible, filtered: $filtersActive, noFilter: !$filtersActive, highlight: $highlight }">

        <button class="btn btn-grey btn-random icon-random"  @click="next()">Ander aanzicht</button>


        <flickity class="card-carousel" ref="flickity" :options="flickityOptions">
            <div class="card-carousel__item" v-for="(map, i) in getMaps" :key="i">
                <img :src="map.image" alt="Woning selector kaart">
                <svg viewBox="0 0 1000 1000">
                    <g>
                        <polygoon
                                v-if="visible"
                                v-for="(points, ii) in map.pointers"
                                :polygonpoints="points.coordinates"
                                :eyemoveid="points.eyemove_id"
                                :key="ii"
                                :active="ii === polygoonStatus || highlight === points.eyemove_id"
                                :index="ii"
                                @newactive="polygoonStatus = $event"
                        ></polygoon>
                    </g>
                </svg>
            </div>
        </flickity>

        <house-tile-slider
                ref="houseslider"
        ></house-tile-slider>



    </div>
</template>

<script>
    import Flickity from 'vue-flickity';
    import HouseTileSlider from '../components/HouseTileSlider.vue'
    import Polygoon from '../components/Polygoon.vue';

    const VueScrollTo = require('vue-scrollto');

    export default {
        props: {
            options:{
                type: Array,
                default: () => []
            },
            mapheight: {
                type: Number
            },
            slidervisible: {
                type: Boolean
            }
        },
        components: {
            Flickity,
            HouseTileSlider,
            Polygoon,
        },

        data() {
            return {
                visible: true,
                flickityOptions: {
                    prevNextButtons: false,
                    pageDots: false,
                    wrapAround: true,
                    setGallerySize: false,
                    draggable: false
//                    imagesLoaded: true
                },
                polygoonStatus: null,
                mapHeight: this.mapheight,
            }
        },

        created(){
            this.$nextTick(() => {
                this.scrollCenter();
            })
        },

        computed: {
            getMaps () {
                let maps = this.$clone(this.$store.state.apiData.maps);
                return maps.map((map) => {
                    map.pointers = map.pointers.filter((pointer) => {
                        return this.$filteredObjectIds.includes(pointer.eyemove_id)
                    })
                    return map
                })
            },
            highlight () {
                return this.$store.state.highlighted
            }
        },
//        watch: {
//            highlight () {
//                this.polygoonStatus = null
//            }
//        },

        methods: {
            next() {
              this.visible = false;
              this.$refs.flickity.next();
              this.$nextTick(() => {
                this.visible = true;
              })

            },
            updateStatus(e){
                this.$refs.houseslider.slideTo(e);
                this.$refs.houseslider.showSlider();
            },
            noActivePolygon() {
                this.polygoonStatus = null
            },


            scrollCenter() {
                const imageheight = window.innerWidth / 100 * this.mapHeight
                const wrapheight = window.innerHeight - 120
                const toscroll = (imageheight - wrapheight) / 2


                VueScrollTo.scrollTo('.card-landscape', {
                    container: '.landscape',
                    easing: 'ease-in',
                    offset: toscroll,
                })
            }
        },
    }
</script>
